import React from 'react';
import { SelectGroup, ButtonV2 } from 'components';

const RewriteTooltip = ({ position, selectedTone, isTouchingUp, onToneSelection, onSubmit, onClose }) => {
  const handleToneSelection = tone => {
    // Ignore the placeholder/disabled option
    if (!tone || tone === '') {
      return;
    }

    onToneSelection(tone);
  };

  return (
    <div
      style={{
        position: 'fixed',
        left: Math.max(10, Math.min(position.x, window.innerWidth - 200)),
        top: Math.max(10, position.y),
        transform: 'translateX(-50%)',
        zIndex: 1001,
        pointerEvents: 'auto'
      }}
    >
      <div className="text-input__touchup-tooltip">
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <SelectGroup
            type="radio"
            className="text-input__touchup-group"
            name="touchup-tone"
            onChange={handleToneSelection}
            checked={selectedTone}
            disabled={isTouchingUp}
            allowUpward={true}
          >
            <SelectGroup.Item value="" label="Select Tone" disabled={true} isDefault={true} />
            <SelectGroup.Item value="friendly" label="Friendly" />
            <SelectGroup.Item value="professional" label="Professional" />
            <SelectGroup.Item value="concise" label="Concise" />
          </SelectGroup>
          <div className="touchup-buttons ">
            <ButtonV2
              icon
              iconName="tick"
              iconSize={24}
              onClick={onSubmit}
              ariaLabel={'Submit'}
              disabled={!selectedTone || selectedTone === '' || isTouchingUp}
            />
            <ButtonV2 icon iconName="close-circle" iconSize={24} onClick={onClose} ariaLabel={'Cancel'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewriteTooltip;
